import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';


export default async function PostActivities({activityName, activityDescription, token}){
    const body = {
        name: activityName,
        description: activityDescription
    }

    const headers = { 'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`}
    
    try {
      const response = await axios.post(`${BASE}/activities`, body, {headers : headers})
      const {data} = response
      
      return data
      
      
    } catch (error) {
      console.error(error);
    } 
}